export enum SelectionPanelNames {
  JOB = 'job',
  PART = 'part',
  SUPPORT_REQUEST = 'support request',
  USER = 'user',
}
